/* 🤖 this file was generated by svg-to-ts */
export const mgcIconUpSmallFilled: {
  name: 'up-small-filled';
  data: string;
} = {
  name: 'up-small-filled',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M11.8 9.197a1.364 1.364 0 0 0-.28.1c-.077.039-.819.749-1.648 1.577C8.221 12.522 8.186 12.566 8.188 13c.001.381.201.703.552.894l.16.086h6.2l.16-.086a.997.997 0 0 0 .551-.893c.004-.434-.03-.477-1.683-2.127-.939-.938-1.568-1.536-1.668-1.585a1.144 1.144 0 0 0-.66-.092"/></svg>`
};
